import { useContext } from "react";
import { AuthContext } from "../../auth";

function useApi() {
  const { api } = useContext(AuthContext);
  return api;
}

export default useApi;
